import Multiselect from 'react-widgets/lib/Multiselect';
import 'react-widgets/dist/css/react-widgets.css';
import Snackbar from '@material-ui/core/Snackbar';
import Scrollbar from 'react-scrollbars-custom';
import MuiAlert from '@material-ui/lab/Alert';
import Card from '@material-ui/core/Card';
import React, { Component } from "react";
import "../MainContent.scss";
function Alert(props) {
	return <MuiAlert elevation={6} variant="filled" {...props} />;
}

class DetailModal extends Component {

	constructor(props) {
		super(props);
		this.state = {
			type:             null,
			showSnackBar:     false,
			textSnackBar:     '',
			severitySnackBar: 'error',
			data: {
				_id:           null,
				name:          "",
				image_url:     null,
				subcategories: [],
				is_active:     false,
				extension:     null
			}
		};
		this.onChange        = this.onChange.bind(this);
		this.changeValue     = this.changeValue.bind(this);
		this.onSave          = this.onSave.bind(this);
		this.onPressCancel   = this.onPressCancel.bind(this);
		this.previewFile     = this.previewFile.bind(this);
		this.onPressDelete   = this.onPressDelete.bind(this);
		this.onPressActivate = this.onPressActivate.bind(this);
	}

	componentDidUpdate(prevProps) {
		if (this.props.isVisible && this.props.data && this.props.isVisible !== prevProps.isVisible) {
			this.setState({
				data: this.props.data
			})
		}
	}

	onChange = e => {
		let data = this.state.data;
		data[e.target.name] = e.target.value;
		this.setState({ data: data });
	}

	changeValue(newOption) {
		let data = this.state.data;
		data.subcategories = newOption;
		this.setState({
			data: data
		})
	}

	onPressCancel() {
		this.closeModal();
		this.props.onPressCancel();
	}

	onSave() {
		if (this.verifyForm()) {
			this.props.onSave(this.state.data);
			this.closeModal();
		}
	}

	onPressActivate() {
		this.props.onPressActivate(this.state.data._id)
	}

	onPressDelete() {
		this.props.onPressDelete(this.state.data._id)
	}


	blobToBase64(blob) {
		return new Promise((resolve, reject) => {
			let reader = new FileReader();
			reader.readAsDataURL(blob);
			reader.onloadend = () => {
				resolve(reader.result.split(',')[1]);
			}
		});
	}

	IsValidImageFormat(file_name) {
		let reg = /^.*\.(svg|SVG|png|PNG)$/
		return reg.test(file_name)
	}

	async previewFile(event) {
		let file = document.querySelector('input[type=file]').files[0];
		if (file !== undefined) {
			if (file.size > 512000) {
				this.setState({
					showSnackBar:     true,
					textSnackBar:     'El archivo debe ser menor a 500 Kilobytes',
					severitySnackBar: 'error',
				});
				event.target.value = null;
				return;
			}
			if (this.IsValidImageFormat(file.name)) {
				let data       = this.state.data;
				let extension  = file.name.split(".");
				data.newImage  = URL.createObjectURL(file);
				data.file      = await this.blobToBase64(file);
				data.extension = extension[1];
				this.setState({
					data: data
				});
			} else {
				window.alert("El formato de la imagen no es valido");
			}
		}
	}

	verifyForm() {
		const type = this.props.type === "category" ? "Categoría" : "Subcategoría"
		let isValidNombre = true;
		let isValidImage = true;
		if (this.state.data.name === null || this.state.data.name === "") {
			this.setState({
				errorName: "El nombre de la " + type + " es requerida.",
			});
			isValidNombre = false;
		}
		if (this.state.data._id === null && !this.state.data.newImage && this.props.type === "category") {
			this.setState({
				errorImage: "La imagen es requerida"
			});
			isValidImage = false
		}

		if (isValidImage && isValidNombre)
			return true
		else
			return false
	}

	closeModal() {
		this.farmazonFormRef.reset();
		this.setState({
			data: {
				_id: null,
				name: "",
				image_url: null,
				subcategories: [],
				is_active: false,
				newImage: null,
				file: null,
				extension: null
			},
			errorName: null,
			errorImage: null
		})
	}

	handleClose = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}
		this.setState({
			showSnackBar: false
		})
	};


	renderButtonActivateDeactivate() {
		if (this.state.data.is_active !== null) {
			const is_active = this.state.data.is_active;
			if (is_active)
				return (
					<button
						className="modal-buttonDeactivate"
						onClick={this.onPressDelete}
					>
						DESACTIVAR
					</button>
				)
			else
				return (
					<button
						className="modal-buttonActivate"
						onClick={this.onPressActivate}
					>
						ACTIVAR
					</button>
				)
		}
	}

	render() {
		const sub = this.state.data.subcategories;
		const subcategories = this.props.subcategoriesToSelect;
		return (
			<div
				className={
					this.props.isVisible ? "modal display-block" : "modal display-none"
				}
			>
				<div className="modal-center-main">
					<Scrollbar style={{ width: '90%', height: '100%' }}>
						<center>
							<div className="auth-group">
								<div className="auth-label"></div>
								<div className="auth-label"></div>
								<form id={"form"}
									ref={el => this.farmazonFormRef = el}></form>
								<table>
									<tbody>
										<tr>
											<td style={{ width: "30%" }}>
												<div className="auth-label">
													<img
														src={this.state.data.newImage ? this.state.data.newImage : this.state.data.image_url}
														width="100%"
														alt={"Elige un archivo"}
													/>
													<br/>
													<input
														type="file"
														id="theFile"
														accept=".svg, .png"
														onChange={this.previewFile}
														form={"form"}
														/>
													<br/><br/>
													<Card>
														<h6 style = {{ fontSize: "14px" }}><b>Consideraciones:</b></h6>
														<small style = {{ fontSize: "10px" }}>
															<b>° Tamaño máximo permitido: </b> 500 KB (kilobytes) <br/>
															<b>° Formato de imagen: </b> .png <br/>
															<b>° Tamaño de imagen: </b> 4088x4088 px
														</small>
														<br/>
													</Card>
												</div>
												<div className="auth-error">
													{this.state.errorImage}
												</div>
											</td>
											<td style={{ width: "70%" }}>
												<div className="auth-label">
													Nombre de la {this.props.type === "category" ? "Categoría" : "Subcategoría"}
													<span className="required">*</span>
													<input
														name="name"
														onChange={this.onChange}
														value={this.state.data.name}
														error={this.state.errorName}
														type="text"
														placeholder={"Ej.: Antianalgesico"}
														className="local-store-input"
														form={"form"}
													/>
												</div>
												<div className="auth-error">
													{this.state.errorName}
												</div>
												<div className="auth-label">
													<Multiselect
														style={{
															marginLeft: "-1.6vh",
															width: "92.9%"
														}}
														form={"form"}
														placeholder="Subcategorías"
														data={subcategories}
														name={"subcategories"}
														valueField='_id'
														textField='name'
														filter='contains'
														value={sub}
														className="local-store-input-select"
														onChange={newOption => {
															this.changeValue(newOption)
														}}
													/>
												</div>
											</td>
										</tr>
										<tr>
											<td style={{ width: "30%" }}></td>
											<td style={{ width: "70%" }}>
												<div className="modal-activity-section">
													<button className="modal-buttonOK" onClick={this.onSave}>
														{!this.state.data._id ? "GUARDAR" : "ACTUALIZAR"}
													</button>
													{
														this.renderButtonActivateDeactivate()
													}
													<button
														className="modal-buttonNo"
														onClick={this.onPressCancel}
													>
														CERRAR
													</button>
												</div>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</center>
					</Scrollbar>
					{
						<Snackbar open={this.state.showSnackBar} autoHideDuration={6000} onClose={this.handleClose}>
							<Alert onClose={this.handleClose} severity={this.state.severitySnackBar}>
								{this.state.textSnackBar}
							</Alert>
						</Snackbar>
					}
				</div>
			</div>
		);

	}

}

export default DetailModal;